// The Inbox status values that are used to filter for the inbox, and which groups the Thread statuses together

const inboxStatus = {
  NEW: "new",
  OPEN: "open",
  BOOKED: "booked",
  CLOSED: "closed",
};

// The Inbox status values that are used to filter for the inbox, and which groups the Thread statuses together

const inboxMobileView = {
  CHAT: "chat",
  ENQUIRY: "enquiry",
};

// The Thread status, this is auto-filled using logic to map the statuses from offers and Admin Thread Info models

const status = {
  NEW: "new",
  OPEN: "open",
  ACCEPTED: "accepted",
  BOOKED: "booked",
  CANCELLED: "cancelled",
  DECLINED: "declined",
  EXPIRED: "expired",
  POSTPONED: "postponed",
  CLOSED_BY_HOST: "closed_by_host",
  BOOKED_BY_HOST: "booked_by_host",
  BOOKED_BY_ORG: "booked_by_org",
  CLOSED_OTHER_BOOKED: "closed_other_booked",
  CLOSED_EVENT_OPEN: "closed_event_open",
  CLOSED_EVENT: "closed_event",
};

// Just a list of common values, includes in other groups below
const common = {
  ACCEPTED: "accepted",
  BOOKED: "confirmed",
  NEW: "new",
  OPEN: "open",
  MODIFY: "modify",
  CLOSED: "closed",
  CANCEL: "cancelled",
  DECLINE: "declined",
  MARK_BOOKED_HOST: "MARKED AS BOOKED BY HOST",
  MARK_CLOSED_HOST: "MARKED AS CLOSED BY HOST",
  MARK_BOOKED_ORG: "MARKED AS BOOKED BY ORGANISER",
  REOPEN: "REOPEN",
};

// Message type values, within the list of messages in a thread
const type = {
  BOOK_NUDGE_HOST: "BOOK_NUDGE_HOST",
  CALL: "call",
  MESSAGE: "message",
  SYSTEM: "system",
  MSG: "msg",
  PAYMENT: "payment",
  PAYMENT_REQUEST: "payment-request",
  POSTPONE: "POSTPONE",
  VIEWING_REQUEST: "viewing-request",
  ...common,
};
// Mode values, used in legacy code for identifying the code behaviour
// DEPRECATED
const mode = {
  // mode to type
  arrangeViewing: type.VIEWING_REQUEST,
  PAYMENT: type.PAYMENT,
  PAYMENT_REQUEST: type.PAYMENT_REQUEST,
  BOOK_NUDGE_HOST: type.BOOK_NUDGE_HOST,
  POSTPONE: type.POSTPONE,
  CALL: type.CALL,
  msg: type.MESSAGE,
  MESSAGE: type.MESSAGE,
  ...common,
};

// Admin Open status values used in the Admin Thread Info model, and is used in the Thread status calculation logic
const adminOpen = {
  OPEN: "OPEN",
  BOOKED: "BOOKED",
  CLOSED: "CLOSED",
  CLOSED_OTHER_BOOKED: "CLOSED - BOOKED OTHER VENUE WITH VS",
  CLOSED_EVENT_OPEN: "CLOSED ENQUIRY, BUT EVENT STILL OPEN",
  MARK_BOOKED_HOST: common.MARK_BOOKED_HOST,
  MARK_BOOKED_ORG: common.MARK_BOOKED_ORG,
};

// Offer status is derived from the last offer status in the message list
const offerStatus = {
  ACTIVE: "active",
  ACCEPTED: "accepted",
  BOOKED: "booked",
  CANCELLED: "cancelled",
  DECLINED: "declined",
  EXPIRED: "expired",
  POSTPONED_BY_HOST: "postponed by host",
  POSTPONED_BY_ORG: "postponed by organiser",
  MARK_CLOSED_HOST: common.MARK_CLOSED_HOST,
  MARK_BOOKED_HOST: common.MARK_BOOKED_HOST,
  MARK_BOOKED_ORG: common.MARK_BOOKED_ORG,
};

// The offer status values, for the offer objects in the message list
const messageOfferStatus = {
  // TODO: is this normal that confirmed & accepted are switched?
  ACCEPTED: "confirmed",
  CONFIRMED: "accepted",
  ACTIVE: "active",
  BOOKED: "booked",
  CANCELLED: "cancelled",
  DECLINED: "declined",
  EXPIRED: "expired",
  POSTPONED_BY_HOST: "postponed by host",
  POSTPONED_BY_ORG: "postponed by organiser",
  MARK_CLOSED_HOST: common.MARK_CLOSED_HOST,
  MARK_BOOKED_HOST: common.MARK_BOOKED_HOST,
  MARK_BOOKED_ORG: common.MARK_BOOKED_ORG,
};

// The lead status values for leads within a thread
const leadStatus = {
  OPEN: "open", // lead suggestion to hosts
  INTERESTED: "interested", // lead accepted by host
  STALE: "stale", // lead has gone quiet
  NOT_INTERESTED: "not-interested", // lead NOT accepted by host
  NOT_ACCEPTED: "not-accepted", // lead NOT accepted by organiser
  ACCEPTED: "accepted", // lead accepted by organiser and enquiry created
  ACCEPTED_ORGANICALLY: "accepted-organically", // space enquired with organically for this event
  EXPIRED: "expired", // event too close
  FREEMIUM_OVER: "freemium-over", // frremiu period over,
};

// Actions are used by the backend and the inbox, to identify which actions are available to which user
const actions = {
  REPLY: "REPLY",
  UNMARK_BOOKED_HOST: "UNMARK_BOOKED_HOST",
  MARK_BOOKED_HOST: "MARK_BOOKED_HOST",
  MARK_CLOSED_HOST: "MARK_CLOSED_HOST",
  UNMARK_BOOKED_ORG: "UNMARK_BOOKED_ORG",
  MARK_BOOKED_ORG: "MARK_BOOKED_ORG",
  SEND_PAYMENT_LINK: "SEND_PAYMENT_LINK",
  ACCEPT: "ACCEPT",
  REACCEPT: "REACCEPT",
  DECLINE_OR_CANCEL: "DECLINE_OR_CANCEL",
  DECLINE: "DECLINE",
  CANCEL: "CANCEL",
  BOOK: "BOOK",
  SUMMARY: "SUMMARY",
  REOPEN: "REOPEN",
  EDIT: "EDIT",
  ARRANGE_VIEWING: "ARRANGE_VIEWING",
  BOOK_NUDGE: "BOOK_NUDGE",
  REQUEST_TO_BOOK: "REQUEST_TO_BOOK",
  CALL: "CALL",
  POSTPONE: "POSTPONE",
};

// enquiryTypes help us distinguish between organic user generated enquiries and those coming through the reccomendatiosn / leads journey
const enquiryType = {
  THREAD: "THREAD",
  HOSTLEAD: "HOSTLEAD",
  ORGANISERLEAD: "ORGANISERLEAD",
};

// Viewing Request statuses
const viewingRequestStatus = {
  OPEN: "OPEN",
  CONFIRMED: "CONFIRMED",
  DECLINED: "DECLINED",
  CANCELLED: "CANCELLED",
  COUNTERED: "COUNTERED",
};

// Mapping from an inbox status, to the thread statuses to be included in the filtering
const inboxStatusThreadStatus = {
  [inboxStatus.NEW]: [status.NEW],
  [inboxStatus.OPEN]: [status.OPEN, status.ACCEPTED, status.BOOKED_BY_ORG],
  [inboxStatus.BOOKED]: [
    status.BOOKED,
    status.BOOKED_BY_HOST,
    status.BOOKED_BY_ORG,
  ],
  [inboxStatus.CLOSED]: [
    status.CANCELLED,
    status.DECLINED,
    status.EXPIRED,
    status.POSTPONED,
    status.CLOSED_BY_HOST,
    status.CLOSED_OTHER_BOOKED,
    status.CLOSED_EVENT_OPEN,
    status.CLOSED_EVENT,
  ],
};

// List of thread statuses, that would be regarded as the Thread being Open
const openThreadStatuses = [
  status.NEW,
  status.ACCEPTED,
  status.OPEN,
  status.BOOKED_BY_ORG,
  status.BOOKED_BY_HOST,
  status.BOOKED,
];

// List of thread statuses, that would be regarded as the Thread not being complete
const incompleteThreadStatuses = [status.NEW, status.ACCEPTED, status.OPEN];

const fetchInboxSortBy = {
  ORGANISER_NAME: "organiser.name",
  SPACE_NAME: "space.name",
  VENUE_NAME: "venue.name",
  HOST_NAME: "host.name",
  EVENT_DATE: "thread.date_from",
  LAST_ACTION_DATE: "thread.latest_message_activity",
};

// Exports the constants
module.exports = {
  adminOpen,
  offerStatus,
  messageOfferStatus,
  leadStatus,
  status,
  actions,
  enquiryType,
  type,
  mode,
  viewingRequestStatus,
  readStatus: {
    NOT_READ: 0,
    EMAIL_SENT: 1,
    READ: 2,
  },
  inboxStatus,
  inboxStatusThreadStatus,
  inboxMobileView,
  openThreadStatuses,
  incompleteThreadStatuses,
  toFlagThreadStatuses: [status.NEW, status.ACCEPTED, status.OPEN],
  fetchInboxSortBy,
};
